// @flow

export default ({
  ...extra
}: jsx$HTMLElement): ExactReactElement_DEPRECATED<'svg'> => ( // $FlowFixMe[cannot-spread-inexact]
  <svg width="16" height="16" viewBox="0 0 16 16" fill="none" {...extra}>
    <path
      d="M11.8447 12.9981C11.5525 12.9981 11.2526 12.8827 11.0296 12.6597L8 9.63014L4.9704 12.6597C4.51672 13.1134 3.78624 13.1134 3.34025 12.6597C2.89427 12.2061 2.88658 11.4756 3.34025 11.0296L6.36986 8L3.34025 4.9704C2.88658 4.52441 2.88658 3.79393 3.34025 3.34025C3.79393 2.88658 4.51672 2.88658 4.9704 3.34025L8 6.36986L11.0296 3.34025C11.4833 2.88658 12.2138 2.88658 12.6597 3.34025C13.1057 3.79393 13.1134 4.52441 12.6597 4.9704L9.63014 8L12.6597 11.0296C13.1134 11.4833 13.1134 12.2138 12.6597 12.6597C12.4368 12.8827 12.1369 12.9981 11.8447 12.9981Z"
      fill="#FE5A4E"
    />
  </svg>
);
